define(
	'C3.ShoppingExtensions.LoginRegister.Register.Countries.View',
	[
		'SCView', 
		'register_countries_dropdown.tpl',
		'Profile.Model',
		//'SC.Configuration',
		'Utils',
		//'Backbone.View'
		],
	function(
		SCViewComponent, 
		register_countries_dropdown_tpl,
		ProfileModel,
		//Configuration,
		Utils,
		//BackboneView
		) {
		'use strict';

		var SCView = SCViewComponent.SCView;

		function RegisterCountriesView(options) {
			SCView.call(this);
			this.options = options || {};
			this.template = register_countries_dropdown_tpl;	

			//console.log(options)	
		}

		// Inherit parent instance methods.
		RegisterCountriesView.prototype = Object.create(SCView.prototype);

		// Restore the constuctor.
		RegisterCountriesView.prototype.constructor = RegisterCountriesView;

		RegisterCountriesView.prototype.getContext = function() {
			var countries = this.options.countries
			,   selectedCountryName = ''

			var self = this;

			//console.log(self.options.selectedCountry)

	        var profile = ProfileModel.getInstance()
			,   is_logged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F'

			_.each(countries,function(country){
            	if(country.code == self.options.selectedCountry){
            		selectedCountryName = country.name
            		//country.isActive = true;
            	}
            });
			return {
				countries: _.values(countries),
	        	isLoggedIn : is_logged_in,
	        	selectedCountryName : selectedCountryName,
	        	hasDefaultCountry : selectedCountryName ? true : false
			}
		}

		// Return the AMD constructor.
		return RegisterCountriesView;
	}
);
